import { teamService } from "../services/teamService";
import { useAsyncData } from "./useAsyncData";

export function useTeamMembers(tenantId?: string | null) {
  return useAsyncData(
    () =>
      tenantId
        ? teamService.listMembers(tenantId)
        : Promise.reject(new Error("No workspace selected.")),
    [tenantId],
  );
}
